import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Popup from "components/popups/popup";
import {
    InputHidden,
    InputSelect,
    InputTel,
    InputText,
} from "components/formElements";
import { requestHelpCall } from "actions/helpCall";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import Validators from "lib/validators";
import I18n from "lib/i18n/i18n";
import defaultCallback from "lib/defaultCallback";
import { convertTimeToLocalTime } from "helpers/dateTimeHelper";
import { imageUrl } from "helpers/ApplicationHelper";

class PopupHelp extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    constructor(props) {
        super(props);

        this.state = {
            requestSubmitted: false,
            submissionProgressState: (() => {
                try {
                    return this.props.submissionProgress.stage;
                } catch (e) {
                    return undefined;
                }
            })(),
            HelpCall: {},
        };

        this._validateName = this._validateName.bind(this);
        this._validatePhone = this._validatePhone.bind(this);
        this._validateTime = this._validateTime.bind(this);
        this._validate = this._validate.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this.generateTimes = this.generateTimes.bind(this);
    }

    componentDidMount() {
        let modalLoaded = new Event("modal-loaded");
        this._name = this.refs["name"];
        this._phone = this.refs["phone"];
        this._time = this.refs["time"];
        this._common_errors_holder = this.refs["common_errors_holder"];
        this.generateTimes();
        document.dispatchEvent(modalLoaded);
    }

    componentWillReceiveProps({ HelpCall, submissionProgress }) {
        if (HelpCall instanceof WorthyApiErrors) {
            let error = HelpCall;
            this._name.setWordlessError();
            this._phone.setWordlessError();
            this._time.setWordlessError();
            this._common_errors_holder.setError(
                I18n.getString("help::errors::cannotSend")
            );
            this.props.onHelpFailed(error);
        } else {
            this.setState({ requestSubmitted: true });
            this.props.onHelpSuccessful();
        }
        if (submissionProgress) {
            if (typeof this.props.submissionProgress.state !== "undefined") {
                this.setState({
                    submissionProgressState:
                        this.props.submissionProgress.state,
                });
            }
        }
    }

    _validateName() {
        this._name.clearErrors();
        if (this._name.state.value.length > 2) {
            return Promise.resolve();
        } else {
            this._name.setError(I18n.getString("help::errors::nameIsTooShort"));
            return Promise.reject();
        }
    }

    _validatePhone() {
        this._phone.clearErrors();
        if (Validators.validatePhone(this._phone.state.value)) {
            return Promise.resolve();
        } else {
            this._phone.setError(I18n.getString("help::errors::phone"));
            return Promise.reject();
        }
    }

    _validateTime() {
        this._time.clearErrors();
        if (this._time.state.value && this._time.state.value !== "") {
            return Promise.resolve();
        } else {
            this._time.setError(I18n.getString("help::errors::selectTime"));
            return Promise.reject();
        }
    }

    _validate() {
        return Promise.all([
            this._name.props.validator(),
            this._phone.props.validator(),
            this._time.props.validator(),
        ]);
    }

    _onSubmit(event) {
        event.preventDefault();

        this._name.clearErrors();
        this._phone.clearErrors();
        this._time.clearErrors();
        this._validate().then(
            () => {
                this.props.onBeforeHelp().then(() => {
                    this.props.requestHelpCall({
                        name: this._name.state.value,
                        phone: this._phone.state.value,
                        timeRange: this._time.state.value,
                        timeZone: "EST",
                    });
                });
            },
            () => {
                //
            }
        );
    }

    generateTimes() {
        var timezone = "America/New_York";
        this.setState({
            timeOptions: {
                "": I18n.getString("help::form::time::placeholder"),
                "9:00am-12:00pm":
                    convertTimeToLocalTime(
                        timezone,
                        "09:00",
                        "HH:mm",
                        "hh:mma"
                    ) +
                    "-" +
                    convertTimeToLocalTime(
                        timezone,
                        "12:00",
                        "HH:mm",
                        "hh:mma z"
                    ),
                "12:00pm-3:00pm":
                    convertTimeToLocalTime(
                        timezone,
                        "12:00",
                        "HH:mm",
                        "hh:mma"
                    ) +
                    "-" +
                    convertTimeToLocalTime(
                        timezone,
                        "15:00",
                        "HH:mm",
                        "hh:mma z"
                    ),
                "3:00pm-8:00pm":
                    convertTimeToLocalTime(
                        timezone,
                        "15:00",
                        "HH:mm",
                        "hh:mma"
                    ) +
                    "-" +
                    convertTimeToLocalTime(
                        timezone,
                        "20:00",
                        "HH:mm",
                        "hh:mma z"
                    ),
            },
        });
    }

    title() {
        return I18n.getString("help::title");
    }

    content() {
        return (
            <div
                className={
                    this.state.requestSubmitted === true ? "submitted" : ""
                }
            >
                <img
                    className="csrs_image"
                    src={imageUrl("help/csrs_second.png")}
                />
                <div className="p1">
                    {!this.props.ADO.working_hour
                        ? I18n.getString("help::serviceClose")
                        : ""}
                    {I18n.getString("help::text1")}
                </div>
                <form onSubmit={this._onSubmit}>
                    <InputText
                        ref="name"
                        name="name"
                        defaultValue={
                            this.props.Session.isLoggedIn
                                ? this.props.Session.userData.name
                                : ""
                        }
                        inputProps={{
                            required: true,
                            autoFocus: false,
                            placeholder: I18n.getString(
                                "help::form::name::placeholder"
                            ),
                        }}
                        validator={this._validateName}
                    />
                    <InputTel
                        ref="phone"
                        name="phone"
                        defaultValue={
                            this.props.Session.isLoggedIn
                                ? this.props.Session.userData.phone
                                : ""
                        }
                        inputProps={{
                            required: true,
                            placeholder: I18n.getString(
                                "help::form::phone::placeholder"
                            ),
                        }}
                        validator={this._validatePhone}
                    />
                    <InputSelect
                        ref="time"
                        name="timeRange"
                        options={this.state.timeOptions}
                        className="preferred-time"
                        validator={this._validateTime}
                    />
                    <InputHidden
                        ref="common_errors_holder"
                        name="common_errors_holder"
                    />
                    <div>
                        <button type="submit" className="btn btn-gold">
                            {I18n.getString("help::submitButton")}
                        </button>
                    </div>
                </form>
                <div className="logos">
                    <img src={imageUrl("common/bbb.png")} />
                    <img src={imageUrl("common/seller_protection.png")} />
                </div>
                <div className="thank-you">
                    <div>{I18n.getString("help::thankYou1")}</div>
                    <div>{I18n.getString("help::thankYou2")}</div>
                </div>
            </div>
        );
    }
}

PopupHelp.propTypes = Object.assign(
    {
        onBeforeHelp: PropTypes.func,
        onHelpSuccessful: PropTypes.func,
        onHelpFailed: PropTypes.func,
    },
    Popup.propTypes
);

PopupHelp.defaultProps = {
    popupClassName: "popup-help",
    onBeforeHelp: defaultCallback,
    onHelpSuccessful: defaultCallback,
    onHelpFailed: defaultCallback,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ requestHelpCall }, dispatch);
};

const mapStateToProps = ({ HelpCall, ADO, Session, submissionProgress }) => {
    return { HelpCall, ADO, Session, submissionProgress };
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupHelp);
